import * as React from "react";

interface GenSelectFilterExplicitOptionProps extends ConnectedListFilterInterface {
  type: "Explicit";
  label: string;
  filterKey: string;
  options: Array<{
    name: string
    value: Filter
  }>
}

interface GenSelectFilterImplicitOptionProps extends ConnectedListFilterInterface {
  label: string;
  filterKey: string;
  options: Array<string>;
  filterGenerator: (option: string) => Filter
}

export default function GenSelectFilter(props: GenSelectFilterExplicitOptionProps | GenSelectFilterImplicitOptionProps) {
  const {
    label,
    filterKey,
    options,
    activeFilters = {},
    addListFilter,
    removeListFilter,
    resetListPages,
    readListPage,
  } = props;

  const currentFilter = activeFilters[filterKey];
  const currentValue = currentFilter ? JSON.stringify(currentFilter) : "All";

  return(
    <div className="gen-list-filter">
      <h5>{label}</h5>
      <select
        value={currentValue || "All"}
        onChange={(e) => {
          if (e.target.value === "All") {
            removeListFilter(filterKey);
          } else {
            addListFilter(filterKey, JSON.parse(e.target.value));
          }
          resetListPages();
          readListPage();
        }}
      >
        <option value="All">All</option>
        {"filterGenerator" in props ?
        props.options.map((option) => (
          <option key={option} value={JSON.stringify(props.filterGenerator(option))}>
            {option}
          </option>
        ),
        ) : props.options.map((option) => (
          <option key={option.name} value={JSON.stringify(option.value)}>
            {option.name}
          </option>
        ),
        )}

      </select>
    </div>
  );
}


